import React from 'react';
import classNames from 'classnames';
import styles from './style.less';

export default ({ text, status, type, absolute, top, right, ...props }) => {
  return (
    <div
      {...props}
      className={classNames(
        styles.badge,
        styles[status],
        styles[type],
        absolute ? styles.absolute : '',
        top ? styles.top : '',
        right ? styles.right : '',
      )}
    >
      <span>{text}</span>
    </div>
  );
};
